<template>
  <div class="mc-widget-call-broadcast__empty-error-state-wrapper">
    <div class="mc-widget-call-broadcast__empty-error-state-img-wrapper">
      <img src="@/assets/images/nodata.png" />
    </div>
    <div class="mc-widget-call-broadcast__empty-error-state-content">
      <h3>{{ $t('trackVideo.broadcast.addVehicle') }}</h3>
      <p>{{ $t('trackVideo.broadcast.addVehicleDesc') }}</p>
    </div>
    <div class="mc-widget-call-broadcast__button-action-wrapper">
      <McButton
        :text="$t('liveView.tab.vehicle')"
        icon="icon-fill_plus"
        @click="$emit('addVehicle')"
      />
      <McButton
        :text="$t('trackVideo.end')"
        icon="icon-outline_phone-off"
        variant="outline-danger"
        @click="$emit('endCall')"
      />
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
export default {
  name: 'EmptyStateBroadcast',
  components: { McButton },
}
</script>
